export interface FAQ {
  question: string;
  answer: string;
}

export const faqList: FAQ[] = [
  {
    question: "17c.c 是什么类型的平台？",
    answer: "17c.c 是一个综合性内容聚合平台，汇聚了资讯、教程、资源、工具推荐等多种类型的内容，致力于为用户提供高效、便捷的内容发现与获取体验。",
  },
  {
    question: "如何访问 17c.c 官网？",
    answer: "您可以直接在浏览器地址栏中输入 17c.c 即可访问我们的官网。我们建议将网站加入书签以便随时访问。",
  },
  {
    question: "17c.c 的内容是否免费？",
    answer: "17c.c 平台上的绝大部分内容均为免费开放，用户可以自由浏览和使用。部分高级资源可能需要注册后获取。",
  },
  {
    question: "如何找到 17c.c 的最新地址？",
    answer: "建议您收藏我们的官方域名 17c.c，或关注我们的社交媒体账号获取最新动态。我们也会通过官方渠道及时发布地址更新信息。",
  },
  {
    question: "17c.c 平台上有哪些内容分类？",
    answer: "17c.c 目前涵盖最新资讯、实用教程、资源下载、效率工具、生活百科和科技前沿六大内容板块，未来还会持续拓展更多分类。",
  },
  {
    question: "我可以在 17c.c 上发布内容吗？",
    answer: "17c.c 目前支持优质内容创作者入驻，如果您有意向成为我们的内容合作伙伴，请通过关于我们页面的联系方式与我们取得联系。",
  },
  {
    question: "17c.c 如何保证内容质量？",
    answer: "我们拥有专业的内容审核团队，对平台上的每一篇文章都进行严格的质量把关，确保信息的准确性和实用性。",
  },
];